import creditEngineRepository, { CreditEngineRepository } from './CreditEngineRepository'
import EzUtils from "@/utils/EzUtils";

const resource = "/lead";
export default {
  getLeadDetails(leadId, mobileNumber, retailerName, partnerReferenceId, officeId) {
    creditEngineRepository.setContentType("application/json");

    let queryParam = ""

    if (leadId) {
      queryParam = `${queryParam}&leadId=${leadId}`
    }
    if (mobileNumber) {
      queryParam = `${queryParam}&mobileNumber=${mobileNumber}`
    }
    if (retailerName) {
      queryParam = `${queryParam}&retailerName=${retailerName}`
    }
    if (partnerReferenceId) {
      queryParam = `${queryParam}&partnerReferenceId=${partnerReferenceId}`
    }

    if (EzUtils.isValidId(officeId)) {
      queryParam = `${queryParam}&officeId=${officeId}`
    }

    if (queryParam) {
      queryParam = `?${queryParam.substring(1)}`
    }
    return CreditEngineRepository.get(`${resource}${queryParam}`);
  },

  getLeadDetailsWithAccessCheck(leadId, mobileNumber) {
    let queryParam = "";

    if (leadId) {
      queryParam = `${queryParam}&leadId=${leadId}`;
    }
    if (mobileNumber) {
      queryParam = `${queryParam}&mobileNumber=${mobileNumber}`;
    }

    if (queryParam) {
      queryParam = `?${queryParam.substring(1)}`;
    }
    creditEngineRepository.setContentType("application/json");
    return CreditEngineRepository.get(`${resource}/access${queryParam}`);
  },

  isSecondaryMobileRequired(leadId, mobileNumber) {
    creditEngineRepository.setContentType("application/json");

    let queryParam = "";

    if (leadId) {
      queryParam = `${queryParam}&leadId=${leadId}`;
    }
    if (mobileNumber) {
      queryParam = `${queryParam}&mobileNumber=${mobileNumber}`;
    }

    if (queryParam) {
      queryParam = `?${queryParam.substring(1)}`;
    }
    return CreditEngineRepository.get(`${resource}/secondaryMobileRequired${queryParam}`);
  },

  sendLeadLinkOnSecondaryMobile(leadId) {
    creditEngineRepository.setContentType("application/json");

    let queryParam = `?leadId=${leadId}`;

    return CreditEngineRepository.post(`${resource}/sendLeadLinkSecondary${queryParam}`);
  }
}
